import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    /* Registro */
    transferencias: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    transferenciasPendientes: true,
    transferenciasPendientesTodos: true

    // cantidadSeleccionadas: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.transferencias = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.transferenciasPendientes = true;
        state.transferenciasPendientesTodos = true;
    },

    'INICIALIZAR'(state) {
        state.transferencias = [];
        // state.cantidadSeleccionadas = 0;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
    'SET_TRANSFERENCIAS'(state, transferencias) {
        state.transferencias = transferencias;

        // state.transferencias = transferencias.map(transferencia => ({
        //     ...transferencia,
        //     selected: false
        // }));
        // state.totalRegistros = state.transferencias.length;
    },
    // 'SELECCIONAR_TRANSFERENCIA' (state) {
    //     state.cantidadSeleccionadas = state.transferencias
    //         .filter(transferencia => transferencia.selected)
    //         .length;
    // }
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    inicializar: ({commit}) => {
        commit('INICIALIZAR');
    },
    getTransferenciasPremios: ( { commit } ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
                + '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');                
            
            if ((/true/i).test(state.transferenciasPendientes)) {
                queryString += '&transferenciasPendientes=true';
            }
    
            if ((/true/i).test(state.transferenciasPendientesTodos)) {
                queryString += '&transferenciasPendientesTodos=true';
            }

            apiAxios.get('bancosmovimientos/transferencias-premios' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        let params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_TRANSFERENCIAS', res.data)
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    save ( { state }, presupuestoInternoId ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (save) {
                let transferencias = [];
                state.transferencias.forEach(transferencia => {
                    if ((/true/i).test(transferencia.selected)) {
                        transferencias.push({
                            id: transferencia.id,
                            rowVersion: transferencia.rowVersion
                        })
                    }
                });
                
                let transferenciaPremiosAsignacion= {
                    presupuestoInternoId: presupuestoInternoId,
                    transferencias,
                };

                apiAxios.post('bancosmovimientos/premios-asignacion', transferenciaPremiosAsignacion)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    // seleccionarTransferencia: ( { commit } ) => {
    //     commit('SELECCIONAR_TRANSFERENCIA');
    // },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}